import type { TFunction } from "i18next";
import type { InputHTMLAttributes } from "react";

/** Props to localize HTML5 constraint validation bubbles (browser default is OS language). */
export function localizedInputValidationProps(
  t: TFunction,
  options?: { email?: boolean },
): Pick<InputHTMLAttributes<HTMLInputElement>, "onInvalid" | "onInput"> {
  return {
    onInvalid: (e) => {
      const el = e.currentTarget;
      if (el.validity.valueMissing) {
        el.setCustomValidity(t("common.validation.required"));
      } else if (options?.email && el.validity.typeMismatch) {
        el.setCustomValidity(t("common.validation.email"));
      } else {
        el.setCustomValidity(t("common.validation.invalid"));
      }
    },
    onInput: (e) => {
      e.currentTarget.setCustomValidity("");
    },
  };
}
